import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(1),
};

export const headerWrapper: SxStyle = {
  background: (p) => p.palette.primary[50],
  padding: (p) => p.spacing(1),
};

export const currentCompanyName: SxStyle = {
  maxWidth: (p) => p.spacing(25),
};

export const overviewHeader: SxStyle = {
  borderBottom: (p) => `1px solid ${p.palette.grey[300]}`,
};

export const searchCompanyNameWrapper: SxStyle = {
  padding: (p) => p.spacing(1, 2),
};

export const header: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  p: 0,
  gap: (p) => p.spacing(1),
};

export const dashed: SxStyle = {
  borderStyle: 'dashed',
  borderColor: (p) => p.palette.primary[100],
};

export const description: SxStyle = {
  border: 0,
  padding: (p) => p.spacing(1, 2),
};
